// pages/ProjectDetailPage.js
import React from 'react';
import ProjectDetails from '../components/project-details';

const ProjectDetailPage = () => {
  return <ProjectDetails />;
};

export default ProjectDetailPage;